import { useState } from "react";
import styles from "./Content.module.css";
import HeaderContent from "./header/HeaderContent";
import PageContent from "./pages/PageContent";

function Content({ view, menuFilterParams, filterControl}) {
  // Parametro geral
  const [selectedDistrito, setSelectedDistrito] = useState("Todos");
  const { onFilterClick, selectedOption, searchInput } = filterControl;

  return (
    <div className={styles.content}>
      <HeaderContent
        view={view}
        distrito={selectedDistrito}
        menuFilterParams={menuFilterParams}
        filterOptions={{
          onFilterClick,
          selectedOption: selectedDistrito,
          onSelectChange: setSelectedDistrito,
        }}
      />
      <PageContent
        view={view}
        distrito={selectedDistrito}
        menuFilterParams={menuFilterParams}
        options={{
          onDistrictMapChange: setSelectedDistrito,
          selectedOption,
          searchInput,
        }}
      />
    </div>
  );
}

export default Content;
